module.exports = __webpack_public_path__ + "assets/img/hallOfFameBg.0250f12e.png";